import { IApplicationState } from '../../types/redux';

export function selectDefaultMessage(state: IApplicationState): string | undefined {
  return state.chatModal.defaultMessage;
}
